export default "__VITE_ASSET__4HwQGsVP__"